import { render, staticRenderFns } from "./BollettazioneRubrica.vue?vue&type=template&id=2ac6ea38"
import script from "./BollettazioneRubrica.vue?vue&type=script&lang=js"
export * from "./BollettazioneRubrica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports